import React from 'react';
import { MapPin, Check } from 'lucide-react';
import { mockData } from '../mock';

const CoverageArea = () => {
  return (
    <section id="coverage" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-950">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="space-y-4">
              <h2 className="text-4xl font-bold text-white">
                {mockData.coverage.title}
              </h2>
              <p className="text-lg text-gray-300 leading-relaxed">
                {mockData.coverage.description}
              </p>
            </div>

            {/* Service Areas List */}
            <div className="grid grid-cols-2 gap-4 pt-4">
              {mockData.coverage.areas.map((area, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <div className="bg-cyan-500/20 rounded-full p-1">
                    <Check className="w-4 h-4 text-cyan-400" />
                  </div>
                  <span className="text-gray-300 font-medium">{area}</span>
                </div>
              ))}
            </div>

            {/* Note */}
            <div className="bg-cyan-500/10 border-l-4 border-cyan-500 p-4 rounded-r-lg">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <p className="text-gray-300">{mockData.coverage.note}</p>
              </div>
            </div>
          </div>

          {/* Right Map Placeholder */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-gray-800">
              <img
                src="https://images.unsplash.com/photo-1589519160732-57fc498494f8?w=800&h=600&fit=crop"
                alt="Georgia counties map"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-600/30 to-purple-600/30"></div>
              
              {/* Map markers overlay */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="bg-gray-900 border-2 border-cyan-500 rounded-xl shadow-2xl p-6 text-center">
                  <MapPin className="w-12 h-12 text-cyan-400 mx-auto mb-3" />
                  <div className="text-2xl font-bold bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">Serving 16 Counties</div>
                  <div className="text-gray-300 mt-2">
                    Across Central Georgia
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoverageArea;
